import {CONTENT_NAME} from '@/constants/main/main-section';
import {SectionHeader} from '@/components/main/common';
import {useEffect, useState} from 'react';
import {Link, useNavigate} from 'react-router-dom';
import VodContentType from '@/components/main/MyPlus/common/ContentType/VodContentType';
import CatchContentType from '@/components/main/MyPlus/common/ContentType/CatchContentType';
import CategoryContentType from '@/components/main/MyPlus/common/ContentType/CategoryContentType';
import StoryContentType from '@/components/main/MyPlus/common/ContentType/StoryContentType';
import CinetyContentType from '@/components/main/MyPlus/common/ContentType/CinetyContentType';
import LiveContentType from '@/components/main/MyPlus/common/ContentType/LiveContentType';
import {SoopLoadingSpinner} from '@/components/ui';

const BTN_POSITION = {
  TOP_RIGHT: 'TOP_RIGHT',
  BOTTOM: 'BOTTOM',
};

/*
 * Section 별로 ContentType 값 존재
 * ContentType 별로 해당 컴포넌트 출력
 *
 * */

const ContentTypeMain = ({
  data,
  contentType,
  hiddenStreamer,
  selectedMode,
  template,
  url,
  btnPosition,
  btnText,
  removeTitle,
  rowCount,
  title,
  useSlider,
  isLoading,
  log = {},
}) => {
  const navigate = useNavigate();

  /*
   * 자식 컴포넌트 렌더링 여부 체크
   * 데이터가 있더라도 자식컴포넌트 내에서 필터링한 데이터가 없으면 출력 X (title, content, divider)
   * 무조건 자식컴포넌트 한번은 렌더링해서 필터링 체크를 해야하므로 첫 상태값 true
   * */
  const [enabledSection, setEnabledSection] = useState(true);
  const [totalBtn, setTotalBtn] = useState({
    location: btnPosition,
    label: btnText,
    url: url,
  });

  const onChangeEnabled = (enabled) => {
    setEnabledSection(enabled);
  };

  useEffect(() => {
    setTotalBtn({
      location: btnPosition,
      label: btnText,
      url: url,
    });
  }, [btnPosition, btnText, url]);

  if (isLoading) {
    return <SoopLoadingSpinner />;
  }
  return (
    enabledSection && (
      <section className={'popular-wrapper'}>
        {!removeTitle && (
          <SectionHeader
            customElement={
              <>
                <h2>
                  <div dangerouslySetInnerHTML={{__html: title}} />
                </h2>
                {totalBtn.location === BTN_POSITION.TOP_RIGHT && (
                  <Link to={totalBtn.url} className='more'>
                    {totalBtn.label}
                  </Link>
                )}
              </>
            }
          />
        )}

        {contentType === CONTENT_NAME.LIVE && (
          <LiveContentType
            data={data}
            selectedMode={selectedMode}
            hiddenStreamer={hiddenStreamer}
            useSlider={useSlider}
            rowCount={rowCount}
            onChangeEnabled={onChangeEnabled}
            log={log}
          />
        )}
        {contentType === CONTENT_NAME.VOD && (
          <VodContentType
            data={data}
            selectedMode={selectedMode}
            hiddenStreamer={hiddenStreamer}
            useSlider={useSlider}
            rowCount={rowCount}
            onChangeEnabled={onChangeEnabled}
            log={log}
          />
        )}
        {contentType === CONTENT_NAME.CATCH && (
          <CatchContentType
            data={data}
            selectedMode={selectedMode}
            hiddenStreamer={hiddenStreamer}
            onChangeEnabled={onChangeEnabled}
            log={log}
          />
        )}

        {contentType === CONTENT_NAME.STORY && (
          <StoryContentType
            data={data}
            selectedMode={selectedMode}
            hiddenStreamer={hiddenStreamer}
            onChangeEnabled={onChangeEnabled}
            log={log}
          />
        )}
        {contentType === CONTENT_NAME.CATEGORY && (
          <CategoryContentType
            data={data}
            selectedMode={selectedMode}
            useSlider={useSlider}
            rowCount={rowCount}
            onChangeEnabled={onChangeEnabled}
          />
        )}
        {contentType === CONTENT_NAME.CINETY && (
          <CinetyContentType
            data={data}
            useSlider={useSlider}
            rowCount={rowCount}
            onChangeEnabled={onChangeEnabled}
            log={log}
          />
        )}
        {totalBtn.location === BTN_POSITION.BOTTOM ? (
          <div className={`show_more`}>
            <button
              type='button'
              onClick={() => {
                if (totalBtn.url.startsWith('http')) {
                  window.location.href = totalBtn.url;
                } else {
                  navigate(totalBtn.url);
                }
              }}>
              {totalBtn.label}
            </button>
          </div>
        ) : (
          <i className={'divider'} />
        )}
      </section>
    )
  );
};

export default ContentTypeMain;
